import {classNames} from '@/core'
import {range} from 'ramda'
import styles from './style.module.styl'

const colors = {
  darkGreen: '#438C91',
  lightBlue: '#9CC8E9',
  green: '#54964B',
  lightGreen: '#88C67A',
  yellow: '#FFC465',
  red: '#C67A7A',
  pink: '#C67AAC',
  purple: '#9D377A',
  darkBlue: '#484C88',
  orange: '#E38C40',
  altBlue: '#5A9BA6'
}

const calcY = (max, min = 0, tickCount = 5) => {
  if (max < tickCount)
    return range(min, max + 1)
  
  const yRange = Math.abs(max - min)
  const unroundedTickSize = yRange / (tickCount - 1)
  const x = Math.ceil(Math.log10(unroundedTickSize) - 1)
  const pow10x = Math.pow(10, x)
  const roundedTickRange = Math.ceil(unroundedTickSize / pow10x) * pow10x
  const min_rounded = roundedTickRange * Math.floor(min / roundedTickRange)
  const max_rounded = roundedTickRange * Math.ceil(max / roundedTickRange)
  return range(0, tickCount).map((v, i) => v * roundedTickRange + min_rounded)
}

export const BarGraph = ({className, values, maxY, color = 'yellow'}) => {
  maxY = maxY || (Math.max(...values.map(([x, y]) => y)) + 1)
  const y = calcY(maxY)
  maxY = y.slice(-1)[0]
  return (
    <div className={classNames(styles.graph, className)} >
      <div className={styles.yWrap}>
        <div className={styles.y}>
          <div>
            {y.map((v, i) => <div>{v}</div>)}
          </div>
          {y.reverse().map((v, i) => <div style={`--top: ${i * 100 / (y.length - 1)}%`} >{v}</div>)}
        </div>
        <div className={styles.lower}>
          {values.map(([label, value]) => <div>{label}</div>)}
        </div>
      </div>
      <div className={styles.bodywrapper}>
        <div className={styles.bodywrapper2}>
          <div className={styles.body}>
            <div className={styles.lines} >
              {y.map((_, i) => 
                <div style={`--top: ${i * 100 / (y.length - 1)}%`} />
              )}
            </div>
            <div className={styles.xWrap}>
              {values.length > 0 &&
                <div className={styles.labelOne}>{values[0][0]}</div>
              }
              <div className={styles.x}>
                {values.map(([label, value]) => 
                  <div>
                    <div className={styles.bar} style={`--bar-height: ${value/maxY * 100}%; --bar-color: ${colors[color]}`} title={value} />
                    <div className={styles.xlabel} ><span>{label}</span></div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.lower}>
          {values.map(([label, value]) => <div>{label}</div>)}
        </div>
      </div>
    </div>
  )
}
